export const locationTypes = [
  { value: 'A', label: 'A - Designated location' },
  { value: 'B', label: 'B - Authorised place' },
  { value: 'C', label: 'C - Approved place' },
  { value: 'D', label: 'D - Other' },
];

export const qualifierTypes = [
  { value: 'T', label: 'T - Postcode address' },
  { value: 'U', label: `U - UN/LOCODE / Client's warehouse ID` },
  { value: 'V', label: 'V - Customs office identifier' },
  { value: 'W', label: 'W - GNSS coordinates' },
  { value: 'X', label: 'X - EORI number' },
  { value: 'Y', label: 'Y - Authorisation number' },
  { value: 'Z', label: 'Z - Address' },
];
